import {AxiosConfig} from "./AxiosConfig/AxiosConfig";
import {IGroup} from "../Interfaces/IGroup";

const searchForGroups = async (filter: string): Promise<Array<IGroup>> => {
    return new Promise<Array<IGroup>>((resolve, reject) => {
        return AxiosConfig.instance.get(`/groups/search?query=${encodeURIComponent(filter)}`).then(res => {
            return resolve(res.data);
        }).catch(error => {
            reject(error);
        });
    });
}

const getGroup = async (id: string): Promise<IGroup> => {
    return new Promise<IGroup>((resolve, reject) => {
        return AxiosConfig.instance.get(`/groups/${id}`).then(res => {
            return resolve(res.data);
        }).catch(error => {
            reject(error);
        });
    });
}

const GroupApi = {
    searchForGroups,
    getGroup
}

export default GroupApi;